/**
 * Zero-pads one digit numbers (for date formats)
 * @return {String}
 */
Number.prototype.zeroPad = function () {
  return (this < 10 ? '0' : '') + this;
};

/**
 * Returns a formated time as: HH:mm
 * @return {String}
 */
Date.prototype.toFormattedTime = function () {
  return [this.getHours().zeroPad(), this.getMinutes().zeroPad()].join(':');
};

export const getMonthYear = (dtString) => {
  if (
    typeof dtString !== 'string' ||
    dtString === null ||
    dtString.length === 0
  ) {
    return;
  }
  const dt = new Date(dtString);
  if (typeof dt.getMonth !== 'function') return;
  const dtTextList = dt.toDateString().split(' ');
  return dtTextList[1] + ', ' + dtTextList[3];
};

/**
 *
 * @param {Date}   Date
 * @returns in YYYY-mm-dd
 */
export const getFormattedDate = (dt) => {
  if (typeof dt.getMonth !== 'function') return;
  /* Month is zero indexed, so need to +1 */
  return [
    dt.getFullYear(),
    (dt.getMonth() + 1).zeroPad(),
    dt.getDate().zeroPad(),
  ].join('-');
};

/**
 *
 * @param {Date}   Date
 * @returns in HH:ss
 */
export const getFormattedTime = (dt) => {
  if (typeof dt.getMonth !== 'function') return;
  return [dt.getHours().zeroPad(), dt.getMinutes().zeroPad()].join(':');
};

/**
 * Print a pretty date, depending on how long ago the date was.
 *
 * @param {Date}   Date
 * @param {boolean}   Don't print times
 * @return {String}
 */
export const prettyDate = (dt, no_time) => {
  if (typeof dt.getMonth !== 'function') return;

  let now = new Date();
  no_time = no_time || false;

  if (
    !no_time &&
    dt.getDate() === now.getDate() &&
    dt.getMonth() === now.getMonth() &&
    dt.getUTCFullYear() === now.getUTCFullYear()
  ) {
    // Same day, print HH:mm
    return dt.toFormattedTime();
  } else if (
    !no_time &&
    dt.getMonth() === now.getMonth() &&
    dt.getFullYear() === now.getFullYear()
  ) {
    // Same month, print (MMMM d, HH:mm)
    return (
      dt.toLocaleString(window.navigator.language, { month: 'short' }) +
      ' ' +
      dt.getDate() +
      ', ' +
      dt.toFormattedTime()
    );
  } else if (dt.getFullYear() === now.getFullYear()) {
    // Same year, print MMMM d
    return (
      dt.toLocaleString(window.navigator.language, { month: 'short' }) +
      ' ' +
      dt.getDate()
    );
  } else {
    // Fallback, print MMMM d, YYYY
    return (
      dt.toLocaleString(window.navigator.language, { month: 'short' }) +
      ' ' +
      dt.getDate() +
      ', ' +
      dt.getFullYear()
    );
  }
};

export const prettyDateFromUTC = (dtString) =>
  prettyDate(new Date(dtString.split(' ').join('T') + 'Z'));

export const checkDOBDateRange = (dob) => {
  const now = new Date();
  const dtDob = new Date(dob);
  const startDob = new Date(
    `${now.getFullYear() - 60}-${(now.getMonth() + 1).zeroPad()}-${now.getDate().zeroPad()}`
  );
  const endDob = new Date(
    `${now.getFullYear() - 13}-${(now.getMonth() + 1).zeroPad()}-${now.getDate().zeroPad()}`
  );
  return dtDob >= startDob && dtDob <= endDob;
};
